import React from 'react';
import { useTranslation } from 'react-i18next';
import RegularButton from 'Douleutaras/components/RegularButton/RegularButton';
import rebookIcon from 'Assets/layout/profile/attributes/rebook.svg';

import { CtaRebookReviewedProps } from './types';
import { CtaSectionContent } from './CtaSectionContent';

export const CtaRebookReviewed: React.FC<CtaRebookReviewedProps> = ({ name, onPrimaryClicked }) => {
  const { t } = useTranslation();

  return (
    <CtaSectionContent icon={rebookIcon}
                       header={t('T.PROS-PROFILE.CTA.START-YOUR-NEW-JOB-WITH {{name}}', { name })}
                       description={t('T.PROS-PROFILE.CTA.DO-YOU-WANT-TO-REBOOK {{name}}', { name })}
                       primaryBtn={
                         <RegularButton modifier="primary"
                                        size="large"
                                        onClick={() => typeof onPrimaryClicked === 'function' && onPrimaryClicked()}
                                        title={t('T.PROS-PROFILE.CTA.REBOOK {{name}}', { name })}
                         />
                       }
                       secondaryBtn={
                         <RegularButton modifier="primary-outline"
                                        size="large"
                                        icon="dashicon dashicon-checkmark"
                                        disabled
                                        onClick={() => {}}
                                        title={t('T.PROS-PROFILE.CTA.REVIEW-POSTED')}
                         />
                       }
    />
  );
};
